export default "__VITE_ASSET__CWPpZvYq__"